import { render, staticRenderFns } from "./set-role.vue?vue&type=template&id=69cc692a&scoped=true"
import script from "./set-role.vue?vue&type=script&lang=js"
export * from "./set-role.vue?vue&type=script&lang=js"
import style0 from "./set-role.vue?vue&type=style&index=0&id=69cc692a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69cc692a",
  null
  
)

export default component.exports